import { AuthService } from '@teko/auth';
import { NotificationService } from '@teko/notification';
import { unregisterUNS } from '../modules/notification/helper';
import {
  LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
  LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
} from '../constants';

export const clearStorageOnSignout = () => {
  [
    LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES,
    LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY,
  ].forEach((lsKey) => localStorage.removeItem(lsKey));
};

export const onSignOut = async (
  authService: AuthService,
  notificationService: NotificationService,
  notificationAppId: string,
  redirectUrl?: string,
): Promise<void> => {
  unregisterUNS(notificationService, notificationAppId);
  authService.logout(redirectUrl);
  clearStorageOnSignout();
};
